var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("small", {}, [
      _c(
        "a",
        {
          class: _vm.upvoteColor,
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.upvoteToggle.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "css-i6dzq1",
              attrs: {
                viewBox: "0 5 24 24",
                width: "15",
                height: "20",
                stroke: "currentColor",
                "stroke-width": "2",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3",
                },
              }),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("small", { staticClass: "me-2" }, [_vm._v(_vm._s(_vm.summary))]),
    _vm._v(" "),
    _c("small", { staticClass: "me-2" }, [
      _c(
        "a",
        {
          class: _vm.downvoteColor,
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.downvoteToggle.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "css-i6dzq1",
              attrs: {
                viewBox: "0 0 24 24",
                width: "15",
                height: "15",
                stroke: "currentColor",
                "stroke-width": "2",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17",
                },
              }),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }